import React, { useState, useEffect, useRef } from 'react';
import { 
  HorizontalTimelineContainer,
  TimelineItem,
  Circle,
  CircleCenter,
  CircleImg
} from "./HorizontalTimeline.style"
import TimelineUp from '../../assets/Timeline/TimelineUp.svg'
import TimelineDown from '../../assets/Timeline/TimelineDown.svg'
import DrLogo from '../../assets/Lines/dr-r-by.png'
import TegorLogo from '../../assets/Lines/tegor-by.png'
import SymbioLogo from '../../assets/Lines/symbio-by.png'
import KvpLogo from '../../assets/Lines/kvp-by.png'
import RegenhialLogo from '../../assets/Lines/regenhial-by.png'
import HelixorLogo from '../../assets/Lines/helixor-by.png'

const useIntersectionObserver = (options) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(entry.isIntersecting);
    }, options);

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [options]);

  return [ref, isVisible];
};

const FadeInLogo = ({ src, alt }) => {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });

  return (
    <img 
      ref={ref}
      src={src} 
      alt={alt}
      style={{
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.5s ease-in-out',
      }}
    />
  );
};

const HorizontalTimeline = () => {
  return(
    <HorizontalTimelineContainer>
      <TimelineItem>
        <Circle marginBottom='5px'>
        <FadeInLogo src={DrLogo} alt="Dr. Reckeweg Logo" />
          <h4>2004</h4>
          <CircleImg>
            <img src={TimelineDown} />
          </CircleImg>
        </Circle>
        <CircleCenter>
        <span></span>
        </CircleCenter>
        <Circle>
        </Circle>
      </TimelineItem>
      <TimelineItem>
        <Circle>
        </Circle>
        <CircleCenter>
        <span></span>
        </CircleCenter>
        <Circle marginTop='-40px'>
        <CircleImg marginTop='-40px'>
            <img src={TimelineUp} />
        </CircleImg>
          <h4>2009</h4>
          <FadeInLogo src={TegorLogo} alt="Tegor Logo" />
        </Circle>
      </TimelineItem>
      <TimelineItem>
        <Circle>
        <FadeInLogo src={SymbioLogo} alt="Symbio Logo" />
          <h4>2013</h4>
          <CircleImg>
            <img src={TimelineDown} />
          </CircleImg>
        </Circle>
        <CircleCenter>
        <span></span>
        </CircleCenter>
        <Circle>
        </Circle>
      </TimelineItem>
      <TimelineItem>
        <Circle>
        </Circle>
        <CircleCenter>
        <span></span>
        </CircleCenter>
        <Circle marginTop='-40px'>    
        <CircleImg marginTop='-40px'>
            <img src={TimelineUp} />
        </CircleImg>
          <h4>2014</h4>
          <FadeInLogo src={RegenhialLogo} alt="Regenhial Logo" />
        </Circle>
      </TimelineItem>
      <TimelineItem>
        <Circle>
        <FadeInLogo src={KvpLogo} alt="KVP Logo" />
          <h4>2020</h4>
          <CircleImg>
            <img src={TimelineDown} />
          </CircleImg>
        </Circle>
        <CircleCenter>
        <span></span>
        </CircleCenter>
        <Circle>
        </Circle>
      </TimelineItem>
      <TimelineItem>
        <Circle>
        </Circle>
        <CircleCenter>
        <span></span>
        </CircleCenter>
        <Circle marginTop='-30px'>
        <CircleImg marginTop='-40px'>
            <img src={TimelineUp} />
        </CircleImg>
          <h4>2021</h4>
          <FadeInLogo src={HelixorLogo} alt="Helixor Logo" />
        </Circle>
      </TimelineItem>
    </HorizontalTimelineContainer>
  )
}

export default HorizontalTimeline
